import { NgModule, LOCALE_ID, APP_INITIALIZER, isDevMode, NgZone } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './views/app/app.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { T4CommonModule } from '../t4common/t4common';

import { NavMenuComponent } from './views/navmenu/navmenu.component';
import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/login.component';

///* Dialogs */
import { ChangePasswordDialog } from './dialogs/changePassword/changePassword';
import { ImpersonateDialog } from './dialogs/impersonate/impersonate';

import { OneWayAdmin } from '../apps/OneWayAdmin/owadmin.module';
import { FleetManagement } from '../apps/FleetManagement/fleet.module';
import { TurboOrder } from '../apps/TurboOrder/turboorder.module';
import { MessagingModule } from '../apps/messages/messages.module';
import { Support } from '../apps/support/support.module';
import { Settings } from '../apps/Settings/settings.module';

import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import localeDa from '@angular/common/locales/da';
import localeNn from '@angular/common/locales/nn';
import localeIs from '@angular/common/locales/is';
import localeDe from '@angular/common/locales/de';
import { BookingsModule } from '../apps/Bookings/booking.module';
import { WelcomeDialog } from './dialogs/welcomeDialog/welcomeDialog';
import { ReportModule } from '../apps/Reports/Report.module';
import { SettingsService } from 't4core';
import { T4coreModule } from 't4core';
import { SendMessageDialog } from '../apps/messages/dialogs/SendMessageDialog/SendMessageDialog';
import { FindBookingDialog } from '../t4common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CampaignsModule } from '../apps/Campaigns/campaigns.module';
import { T4Environment } from 't4core';
import { CustomerServiceModule } from '../apps/CustomerService/customerservice.module';
import { Use4FreeModule } from '../apps/Use4Free/use4free.module';

// Register languages
registerLocaleData(localeSv);
registerLocaleData(localeDa);
registerLocaleData(localeNn);
registerLocaleData(localeIs);
registerLocaleData(localeDe);

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        LoginComponent,
        ChangePasswordDialog,
        ImpersonateDialog,
        WelcomeDialog
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        T4coreModule.forRoot({ dialogs: [{ key: "T4.Messaging.SendMessage", dialog: SendMessageDialog }, { key: "Sho", dialog: FindBookingDialog }] }),
        T4CommonModule,
        RouterModule.forRoot([
            { path: '', redirectTo: '/Bookings/Dashboard', pathMatch: 'full' },
        ], { initialNavigation: 'disabled' }),
        OneWayAdmin,
        BookingsModule,
        MessagingModule,
        TurboOrder,
        FleetManagement,
        Support,
        Settings,
        ReportModule,
        CampaignsModule,
        CustomerServiceModule,
        Use4FreeModule
    ],
    providers: [T4CommonModule,
        { provide: APP_INITIALIZER, useFactory: initApp, deps: [SettingsService, NgZone], multi: true },
        {
            provide: LOCALE_ID,
            useFactory: (settings: SettingsService) => {
                if (settings.clientSettings && settings.clientSettings.Language == "no")
                    return "nn";
                return settings.clientSettings ? settings.clientSettings.Language : 'sv';
            },
            deps: [SettingsService]
        },
        //{
        //  provide: MAT_DATE_LOCALE, useValue: 'sv_SE'
        //}
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// App initialization
export function initApp(settingsService: SettingsService, zone: NgZone) {
  return () => {
    settingsService.appName = "T4 Client";

    if (isDevMode()) {
      settingsService.setEnvironment(T4Environment.Development, true);
    } else {
      settingsService.appInsightsKey = '49105e74-a2c5-4fe9-b808-45484be3ce83';
    }
  };
}
// App initialization
